import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "appTitle": "DiTasq — Supplier Portal",
      "appFooter": "DiTasq — Supplier Portal ©{{year}} Created by Waveform",

      "login": "Login",
      "register": "Register",
      "logout": "Logout",
      "email": "Email",
      "password": "Password",
      "firstName": "First Name",
      "lastName": "Last Name",
      "supplierName": "Supplier Name",
      "alreadyHaveAccount": "Already have an account?",
      "loginHere": "Login here",
      "dontHaveAccount": "Don't have an account?",
      "registerHere": "Register here",
      "loginSubtitle": "Sign in to your supplier account",
      "loginSuccess": "Login successful!",
      "loginError": "Login error",
      "invalidCredentials": "Invalid credentials",
      "networkError": "Network error. Please check your connection.",
      "emailAlreadyExists": "An account with this email already exists",
      "registerProfileError": "Registration could not be completed. Please try again.",
      "emailRequired": "Email is required",
      "emailInvalid": "Invalid email",
      "passwordRequired": "Password is required",
      "noAccount": "No account?",
      "registerSuccess": "Registration successful!",
      "registerError": "Registration error",
      "registerSubtitle": "Create your supplier account",
      "supplierNameRequired": "Supplier name is required",
      "firstNameRequired": "First name is required",
      "lastNameRequired": "Last name is required",
      "passwordMinLength": "Password must be at least 6 characters",
      "confirmPassword": "Confirm Password",
      "confirmPasswordRequired": "Please confirm your password",
      "passwordsMismatch": "Passwords do not match",

      "dashboard": "Dashboard",
      "requests": "Requests",
      "administration": "ADMINISTRATION",
      "equipment": "Equipment",
      "consumables": "Consumables",
      "teams": "Teams",
      "services": "Services",

      "noRequests": "No requests",
      "all": "All",
      "quoteNumber": "Quote #",
      "status": "Status",
      "customer": "Customer",
      "total": "Total",
      "createdAt": "Created At",
      "statusPendingSP": "Pending Supplier",
      "statusPendingCustomer": "Pending Customer",
      "statusAccepted": "Accepted",
      "statusCustomerRejected": "Customer Rejected",
      "statusSPRejected": "Supplier Rejected",
      "quoteDetail": "Quote Detail",
      "back": "Back",
      "items": "Items",
      "quantity": "Quantity",
      "subtotal": "Subtotal",
      "tax": "Tax",
      "sendQuote": "Send Quote",
      "rejectQuote": "Reject Quote",
      "messages": "Messages",
      "noMessages": "No messages yet",
      "messagePlaceholder": "Write a message...",
      "sendMessage": "Send",
      "geoLocation": "Location",
      "supplier": "Supplier",
      "loadError": "Failed to load data",
      "quoteSentSuccess": "Quote sent successfully",
      "quoteRejectedSuccess": "Quote rejected",
      "messageSentSuccess": "Message sent",
      "operationError": "Operation failed",

      "welcome": "Welcome to DiTasq — Supplier Portal!",
      "welcomeMessage": "Manage your equipment, consumables, teams and services from here.",
      "totalEquipment": "Total Equipment",
      "totalConsumables": "Total Consumables",
      "totalTeamMembers": "Total Team Members",
      "totalServices": "Total Services",
      "totalRequests": "Total Requests",
      "manageEquipment": "Track and manage your machinery and equipment.",
      "manageConsumables": "Keep your consumables inventory up to date.",
      "manageTeams": "Manage your team members and availability.",
      "manageServices": "Manage the services you offer.",

      "equipmentManagement": "Equipment Management",
      "consumablesManagement": "Consumables Management",
      "teamsManagement": "Teams Management",
      "servicesManagement": "Services Management",

      "add": "Add",
      "edit": "Edit",
      "delete": "Delete",
      "save": "Save",
      "cancel": "Cancel",
      "search": "Search",
      "actions": "Actions",
      "confirmDelete": "Are you sure you want to delete this item?",
      "deleteConfirm": "Are you sure you want to delete this item?",
      "yes": "Yes",
      "no": "No",
      "totalItems": "{{total}} items",

      "createSuccess": "Created successfully",
      "updateSuccess": "Updated successfully",
      "deleteSuccess": "Deleted successfully",
      "saveError": "Failed to save",
      "deleteError": "Failed to delete",

      "nameRequired": "Name is required",
      "unitRequired": "Unit is required",
      "unitPriceRequired": "Unit price is required",
      "descriptionRequired": "Description is required",
      "taxValueRequired": "Tax value is required",
      "dateFormat": "Format must be DD-MM-YYYY",
      "invalidFormat": "Invalid format",
      "selectUnit": "Select unit",
      "selectTaxValue": "Select tax value",
      "notes": "Notes",
      "additionalNotes": "Additional notes",

      "addEquipment": "Add Equipment",
      "editEquipment": "Edit Equipment",
      "name": "Name",
      "brand": "Brand",
      "model": "Model",
      "serialNumber": "Serial Number",
      "power": "Power",
      "powerPlaceholder": "e.g. 1200 W",
      "purchaseDate": "Purchase Date",
      "acquisitionValue": "Acquisition Value",
      "unit": "Unit",
      "unitPrice": "Unit Price",
      "description": "Description",
      "typeLabel": "Type",
      "typeRequired": "Type is required",
      "typeVehicle": "Vehicle",
      "typeTool": "Tool",
      "typePowerTool": "Power Tool",
      "typeConsumable": "Consumable",
      "typeManPower": "Team Member",

      "addConsumable": "Add Consumable",
      "editConsumable": "Edit Consumable",
      "reference": "Reference",

      "addTeamMember": "Add Team Member",
      "editTeamMember": "Edit Team Member",
      "job": "Job",
      "jobTitle": "Job Title",
      "jobTitleRequired": "Job title is required",
      "birthDate": "Birth Date",
      "birthDateRequired": "Birth date is required",

      "addService": "Add Service",
      "editService": "Edit Service",
      "taxValue": "Tax Value",
      "category": "Category",
      "subCategory": "Sub Category",

      "unitNA": "N/A",
      "hour": "Hour",
      "day": "Day",
      "unit_generic": "Unit",
      "month": "Month",
      "year": "Year",
      "meter": "Meter",
      "squareMeter": "Square Meter",
      "squareKilometer": "Square Kilometer",
      "cubicMeter": "Cubic Meter",
      "cubicKilometer": "Cubic Kilometer",
      "kilometer": "Kilometer",
      "ton": "Ton",
      "kilogram": "Kilogram",
      "hectare": "Hectare",
      "acre": "Acre",
      "litre": "Litre",
      "alqueire": "Alqueire",

      "tax_exempt": "Exempt",
      "tax_reduced": "Reduced (6%)",
      "tax_intermediate": "Intermediate (13%)",
      "tax_normal": "Normal (23%)"
    }
  },
  pt: {
    translation: {
      "appTitle": "DiTasq — Portal do Fornecedor",
      "appFooter": "DiTasq — Portal do Fornecedor ©{{year}} Criado por Waveform",

      "login": "Entrar",
      "register": "Registar",
      "logout": "Sair",
      "email": "Email",
      "password": "Palavra-passe",
      "firstName": "Primeiro Nome",
      "lastName": "Último Nome",
      "supplierName": "Nome do Fornecedor",
      "alreadyHaveAccount": "Já tem uma conta?",
      "loginHere": "Entre aqui",
      "dontHaveAccount": "Não tem uma conta?",
      "registerHere": "Registe-se aqui",
      "loginSubtitle": "Inicie sessão na sua conta de fornecedor",
      "loginSuccess": "Login efetuado com sucesso!",
      "loginError": "Erro ao fazer login",
      "invalidCredentials": "Credenciais inválidas",
      "networkError": "Erro de rede. Verifique a sua ligação.",
      "emailAlreadyExists": "Já existe uma conta com este email",
      "registerProfileError": "Não foi possível concluir o registo. Por favor, tente novamente.",
      "emailRequired": "Email é obrigatório",
      "emailInvalid": "Email inválido",
      "passwordRequired": "Palavra-passe é obrigatória",
      "noAccount": "Sem conta?",
      "registerSuccess": "Registo efetuado com sucesso!",
      "registerError": "Erro ao registar",
      "registerSubtitle": "Crie a sua conta de fornecedor",
      "supplierNameRequired": "Nome do fornecedor é obrigatório",
      "firstNameRequired": "Primeiro nome é obrigatório",
      "lastNameRequired": "Último nome é obrigatório",
      "passwordMinLength": "A palavra-passe deve ter pelo menos 6 caracteres",
      "confirmPassword": "Confirmar Palavra-passe",
      "confirmPasswordRequired": "Por favor confirme a palavra-passe",
      "passwordsMismatch": "As palavras-passe não coincidem",

      "dashboard": "Dashboard",
      "requests": "Pedidos",
      "administration": "ADMINISTRAÇÃO",
      "equipment": "Equipamentos",
      "consumables": "Consumíveis",
      "teams": "Equipas",
      "services": "Serviços",

      "noRequests": "Sem pedidos",
      "all": "Todos",
      "quoteNumber": "N.º Orçamento",
      "status": "Estado",
      "customer": "Cliente",
      "total": "Total",
      "createdAt": "Data de Criação",
      "statusPendingSP": "Pendente Fornecedor",
      "statusPendingCustomer": "Pendente Cliente",
      "statusAccepted": "Aceite",
      "statusCustomerRejected": "Rejeitado pelo Cliente",
      "statusSPRejected": "Rejeitado pelo Fornecedor",
      "quoteDetail": "Detalhe do Orçamento",
      "back": "Voltar",
      "items": "Artigos",
      "quantity": "Quantidade",
      "subtotal": "Subtotal",
      "tax": "IVA",
      "sendQuote": "Enviar Orçamento",
      "rejectQuote": "Rejeitar Orçamento",
      "messages": "Mensagens",
      "noMessages": "Ainda sem mensagens",
      "messagePlaceholder": "Escreva uma mensagem...",
      "sendMessage": "Enviar",
      "geoLocation": "Localização",
      "supplier": "Fornecedor",
      "loadError": "Erro ao carregar dados",
      "quoteSentSuccess": "Orçamento enviado com sucesso",
      "quoteRejectedSuccess": "Orçamento rejeitado",
      "messageSentSuccess": "Mensagem enviada",
      "operationError": "A operação falhou",

      "welcome": "Bem-vindo ao DiTasq — Portal do Fornecedor!",
      "welcomeMessage": "Gerir os seus equipamentos, consumíveis, equipas e serviços a partir daqui.",
      "totalEquipment": "Total de Equipamentos",
      "totalConsumables": "Total de Consumíveis",
      "totalTeamMembers": "Total de Membros da Equipa",
      "totalServices": "Total de Serviços",
      "totalRequests": "Total de Pedidos",
      "manageEquipment": "Controle e gira as suas máquinas e equipamentos.",
      "manageConsumables": "Mantenha o seu inventário de consumíveis atualizado.",
      "manageTeams": "Gira os membros da sua equipa e disponibilidade.",
      "manageServices": "Gira os serviços que oferece.",

      "equipmentManagement": "Gestão de Equipamentos",
      "consumablesManagement": "Gestão de Consumíveis",
      "teamsManagement": "Gestão de Equipas",
      "servicesManagement": "Gestão de Serviços",

      "add": "Adicionar",
      "edit": "Editar",
      "delete": "Apagar",
      "save": "Guardar",
      "cancel": "Cancelar",
      "search": "Pesquisar",
      "actions": "Ações",
      "confirmDelete": "Tem a certeza que deseja apagar este item?",
      "deleteConfirm": "Tem a certeza que deseja apagar este item?",
      "yes": "Sim",
      "no": "Não",
      "totalItems": "{{total}} itens",

      "createSuccess": "Criado com sucesso",
      "updateSuccess": "Atualizado com sucesso",
      "deleteSuccess": "Apagado com sucesso",
      "saveError": "Erro ao guardar",
      "deleteError": "Erro ao apagar",

      "nameRequired": "O nome é obrigatório",
      "unitRequired": "A unidade é obrigatória",
      "unitPriceRequired": "O preço unitário é obrigatório",
      "descriptionRequired": "A descrição é obrigatória",
      "taxValueRequired": "O valor do IVA é obrigatório",
      "dateFormat": "O formato deve ser DD-MM-AAAA",
      "invalidFormat": "Formato inválido",
      "selectUnit": "Selecionar unidade",
      "selectTaxValue": "Selecionar valor do IVA",
      "notes": "Notas",
      "additionalNotes": "Notas adicionais",

      "addEquipment": "Adicionar Equipamento",
      "editEquipment": "Editar Equipamento",
      "name": "Nome",
      "brand": "Marca",
      "model": "Modelo",
      "serialNumber": "Número de Série",
      "power": "Potência",
      "powerPlaceholder": "ex.: 1200 W",
      "purchaseDate": "Data de Compra",
      "acquisitionValue": "Valor de Aquisição",
      "unit": "Unidade",
      "unitPrice": "Preço Unitário",
      "description": "Descrição",
      "typeLabel": "Tipo",
      "typeRequired": "O tipo é obrigatório",
      "typeVehicle": "Veículo",
      "typeTool": "Ferramenta",
      "typePowerTool": "Ferramenta Elétrica",
      "typeConsumable": "Consumível",
      "typeManPower": "Membro da Equipa",

      "addConsumable": "Adicionar Consumível",
      "editConsumable": "Editar Consumível",
      "reference": "Referência",

      "addTeamMember": "Adicionar Membro da Equipa",
      "editTeamMember": "Editar Membro da Equipa",
      "job": "Função",
      "jobTitle": "Função",
      "jobTitleRequired": "A função é obrigatória",
      "birthDate": "Data de Nascimento",
      "birthDateRequired": "A data de nascimento é obrigatória",

      "addService": "Adicionar Serviço",
      "editService": "Editar Serviço",
      "taxValue": "Valor do IVA",
      "category": "Categoria",
      "subCategory": "Sub Categoria",

      "unitNA": "N/D",
      "hour": "Hora",
      "day": "Dia",
      "unit_generic": "Unidade",
      "month": "Mês",
      "year": "Ano",
      "meter": "Metro",
      "squareMeter": "Metro Quadrado",
      "squareKilometer": "Quilómetro Quadrado",
      "cubicMeter": "Metro Cúbico",
      "cubicKilometer": "Quilómetro Cúbico",
      "kilometer": "Quilómetro",
      "ton": "Tonelada",
      "kilogram": "Quilograma",
      "hectare": "Hectare",
      "acre": "Acre",
      "litre": "Litro",
      "alqueire": "Alqueire",

      "tax_exempt": "Isento",
      "tax_reduced": "Reduzida (6%)",
      "tax_intermediate": "Intermédia (13%)",
      "tax_normal": "Normal (23%)"
    }
  }
};

const getInitialLanguage = () => {
  const stored = localStorage.getItem('lang');
  if (stored) {
    return stored;
  }
  return navigator.language?.toLowerCase().startsWith('pt') ? 'pt' : 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('lang', lng);
});

export default i18n;
